module.exports = __webpack_public_path__ + "static/media/sidebar_rooms_blue.5a730b1f.svg";